/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const email = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.255 3.313C1.097 3.493 1 3.734 1 4v8c0 .552.418 1 .933 1h12.134c.515 0 .933-.448.933-1V4c0-.27-.1-.515-.262-.695m-13.483.008A.903.903 0 0 1 1.933 3h12.134a.9.9 0 0 1 .67.305m-13.482.008 5.928 4.57c.24.184.525.284.817.284.292 0 .577-.1.817-.285l5.92-4.577"
    />
  </svg>
)
export default email
